<template>
    <div class="notice__item-actions">

        <form  class="notice__form" action="#">


            <template v-if="notice.type === 'pet_ownership' && ! notice.sender_id"></template>
            <template v-else>

                <template v-if="notice.type === 'pet_ownership' && notice.interactionEntry.interaction.status === 'accepted'"></template>
                <template v-else>
                    <fieldset class="notice__form-fieldset d-flex">

                        <div class="notice__form-item" v-if="notice.type !== 'homestay' && notice.type !== 'pet_ownership'">
                            <date-picker v-model="$v.requestForm.timeTo.$model" value-type="format" format="YYYY-MM-DD 20:00:00" placeholder="Актуально до:"></date-picker>
                            <div class="field-error-text" v-if="$v.requestForm.timeTo.$error">Выбраная дата не может быть прошедшей.</div>
                        </div>
                        <div class="notice__form-item">
                            <input type="text" v-model="$v.requestForm.phone.$model"
                                   v-mask="'+375 (##) ###-##-##'" placeholder="+375 (29) 111-11-11">
                            <div class="field-error-text" v-if="$v.requestForm.phone.$error">Номер телефона неверный</div>
                        </div>
                    </fieldset>
                </template>

                <fieldset class="notice__form-fieldset">
                    <div class="notice__form-item notice__form-item--full">
                        <textarea rows="4" name="comment" v-model="$v.requestForm.comment.$model" placeholder="Оставьте комментарий"></textarea>
                        <div class="field-error-text" v-if="$v.requestForm.comment.$error">Длина комментария должна быть не меньше 30 символов.</div>
                    </div>
                </fieldset>

            </template>



            <template v-if="notice.type === 'pet_ownership'">

                <fieldset class="notice__form-fieldset" v-if="notice.interactionEntry.interaction.status === 'accepted'">
                    <div class="notice__form-item notice__form-item--full">
                        <button class="notice__item-actions-btn notice__item-actions-btn--primary"
                                @click.prevent="petOwershipRequestReply(notice.interactionEntry.interaction_id, 'processed')">Отдать питомца</button>
                        <button class="notice__item-actions-btn notice__item-actions-btn--secondary"
                                @click.prevent="petOwershipRequestReply(notice.interactionEntry.interaction_id, 'rejected')">Не отдавать</button>
                    </div>
                </fieldset>

                <fieldset class="notice__form-fieldset" v-if="notice.interactionEntry.interaction.status === 'created'">
                    <div class="notice__form-item notice__form-item--full">
                        <button class="notice__item-actions-btn notice__item-actions-btn--primary"
                                @click.prevent="petOwershipRequestReply(notice.interactionEntry.interaction_id, 'processed')">Отдать питомца</button>
                        <button class="notice__item-actions-btn notice__item-actions-btn--primary" v-if="notice.sender_id"
                                @click.prevent="petOwershipRequestReply(notice.interactionEntry.interaction_id, 'accepted')">Принять</button>
                        <button class="notice__item-actions-btn notice__item-actions-btn--secondary"
                                @click.prevent="petOwershipRequestReply(notice.interactionEntry.interaction_id, 'rejected')">Отклонить</button>
                    </div>
                </fieldset>

            </template>

            <template v-else-if="notice.interactionEntry && notice.interactionEntry.action === 'donorship_request'">
                <fieldset class="notice__form-fieldset" v-if="notice.interactionEntry.interaction.status === 'created'">
                    <div class="notice__form-item notice__form-item--full">
                        <button class="notice__item-actions-btn notice__item-actions-btn--primary"
                                @click.prevent="donorshipRequestReply(notice.interactionEntry.interaction_id, 'processed')">Принять</button>
                        <button class="notice__item-actions-btn notice__item-actions-btn--primary"
                                @click.prevent="donorshipRequestReply(notice.interactionEntry.interaction_id, 'accepted')">Обсудить</button>
                        <button class="notice__item-actions-btn notice__item-actions-btn--secondary"
                                @click.prevent="donorshipRequestReply(notice.interactionEntry.interaction_id, 'rejected')">Отклонить</button>
                    </div>
                </fieldset>

                <fieldset class="notice__form-fieldset" v-if="notice.interactionEntry.interaction.status === 'accepted'">
                    <div class="notice__form-item notice__form-item--full">
                        <button class="notice__item-actions-btn notice__item-actions-btn--primary"
                                @click.prevent="donorshipRequestReply(notice.interactionEntry.interaction_id, 'processed')">Подтвердить</button>
                        <button class="notice__item-actions-btn notice__item-actions-btn--secondary"
                                @click.prevent="donorshipRequestReply(notice.interactionEntry.interaction_id, 'rejected')">Отказать</button>
                    </div>
                </fieldset>
            </template>

            <template v-else-if="notice.interactionEntry && notice.interactionEntry.action === 'homestay_request'">
                <fieldset class="notice__form-fieldset" v-if="notice.interactionEntry.interaction.status === 'accepted'">
                    <div class="notice__form-item notice__form-item--full">
                        <button class="notice__item-actions-btn notice__item-actions-btn--primary"
                                @click.prevent="homestayRequestReply(notice.interactionEntry.interaction_id, 'processed')">Подтвердить</button>
                        <button class="notice__item-actions-btn notice__item-actions-btn--secondary"
                                @click.prevent="homestayRequestReply(notice.interactionEntry.interaction_id, 'rejected')">Отказать</button>
                    </div>
                </fieldset>

                <fieldset class="notice__form-fieldset" v-if="notice.interactionEntry.interaction.status === 'created'">
                    <div class="notice__form-item notice__form-item--full">
                        <button class="notice__item-actions-btn notice__item-actions-btn--primary"
                                @click.prevent="homestayRequestReply(notice.interactionEntry.interaction_id, 'processed')">Принять</button>
                        <button class="notice__item-actions-btn notice__item-actions-btn--primary"
                                @click.prevent="homestayRequestReply(notice.interactionEntry.interaction_id, 'accepted')">Обсудить</button>
                        <button class="notice__item-actions-btn notice__item-actions-btn--secondary"
                                @click.prevent="homestayRequestReply(notice.interactionEntry.interaction_id, 'rejected')">Отклонить</button>
                    </div>
                </fieldset>
            </template>

            <template v-else-if="notice.interactionEntry &&
            (notice.interactionEntry.action === 'pr_help_request' || notice.interactionEntry.action === 'photo_help_request' ||
              notice.interactionEntry.action === 'auto_help_request') || notice.interactionEntry.action === 'giveaway_request'">

                <fieldset class="notice__form-fieldset" v-if="notice.interactionEntry.interaction.status === 'accepted'">
                    <div class="notice__form-item notice__form-item--full">
                        <button class="notice__item-actions-btn notice__item-actions-btn--primary"
                                @click.prevent="helpRequestReply(notice.interactionEntry.interaction_id, 'processed')">Подтвердить</button>
                        <button class="notice__item-actions-btn notice__item-actions-btn--secondary"
                                @click.prevent="helpRequestReply(notice.interactionEntry.interaction_id, 'rejected')">Отказать</button>
                    </div>
                </fieldset>

                <fieldset class="notice__form-fieldset" v-if="notice.interactionEntry.interaction.status === 'created'">
                    <div class="notice__form-item notice__form-item--full">
                        <button class="notice__item-actions-btn notice__item-actions-btn--primary"
                                @click.prevent="helpRequestReply(notice.interactionEntry.interaction_id, 'processed')">Принять</button>
                        <button class="notice__item-actions-btn notice__item-actions-btn--primary"
                                @click.prevent="helpRequestReply(notice.interactionEntry.interaction_id, 'accepted')">Обсудить</button>
                        <button class="notice__item-actions-btn notice__item-actions-btn--secondary"
                                @click.prevent="helpRequestReply(notice.interactionEntry.interaction_id, 'rejected')">Отклонить</button>
                    </div>
                </fieldset>
            </template>


        </form>

    </div>
</template>

<script>

import {mask} from 'vue-the-mask'
import {helpers, required, minLength, requiredIf} from 'vuelidate/lib/validators';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
const phoneValidator = helpers.regex('phone', /^\+375\s\((29|44|33|25)\)\s[1-9]{1}\d{2}-\d{2}-\d{2}$/g);


export default {
    name: "NoticeModerationForm",
    props: ['notice'],
    components: {
        DatePicker
    },
    directives: {mask},
    data(){
        return{
            requestStatus: null,
            requestForm:{
                timeTo: null,
                comment: null,
                phone: null,

            },
        }
    },

    computed:{
        noticeType(){
            if(!this.notice) return
            let type = this.notice.type

            switch (type){
                case 'photo_help':
                    type = 'photo-help'
                    break;
                case 'pr_help':
                    type = 'pr-help'
                    break;
                case 'auto_help':
                    type = 'auto-help'
                    break;
                case 'giveaway':
                    type = 'giveaway'
                    break;

                default:
                    break;
            }

            return type

        }
    },

    mounted(){},

    validations: {
        requestForm: {
            timeTo: {
                required: requiredIf(function (){

                    if(this.notice.type === 'homestay'  ||  this.notice.type === 'pet_ownership') return false

                    if(this.notice.type === 'donorship' && this.requestStatus === 'rejected'){
                        return this.notice.type === 'donorship' && this.requestStatus === 'rejected'
                    }

                    return this.requestStatus === 'accepted'
                }),
                minValue: function (value){

                    if(this.notice.type === 'homestay'  ||  this.notice.type === 'pet_ownership') return true

                    if(this.requestStatus === 'accepted'){
                        return value > new Date().toISOString()
                    }

                    return true
                }
            },
            phone:{
                required: requiredIf(function (){
                    return this.requestStatus === 'accepted'
                }),
                phoneValidator
            },
            comment: {
                required: requiredIf(function (){

                    return ! ( this.notice.type  ===  'pet_ownership'  &&  ! this.notice.sender_id );

                }),
                minLength: minLength(30)
            }
        },
    },
    methods:{

        helpRequestReply(id, status){
            let self = this,
                url = `/api/interactions/${this.noticeType}/reply`;

            this.requestStatus = status

            self.$v.$touch();
            if (self.$v.requestForm.$invalid) {
                return false;
            }

            let params = {
                "interaction_id": +id,
                "status": status,
                "comment": this.requestForm.comment,
            }

            if(this.requestForm.phone){
                params = Object.assign(
                    {},
                    params,
                    {
                        "details": {
                            "phone":  this.requestForm.phone.replace(/([(]|[)])|(-)|(\s)/g,'')
                        }
                    })
            }

            switch (this.requestStatus){
                case 'rejected':
                    params = {
                        "interaction_id": +id,
                        "status": status,
                        "comment": this.requestForm.comment,
                    }

                    if(this.requestForm.phone){
                        params = Object.assign(
                            {},
                            params,
                            {
                                "details": {
                                    "phone":  this.requestForm.phone.replace(/([(]|[)])|(-)|(\s)/g,'')
                                }
                            })
                    }


                    break;
                case 'processed':
                    params = {
                        "interaction_id": +id,
                        "status": status,
                        "comment": this.requestForm.comment,
                    }

                    break;
                default:
                    break;
            }

            axios.post(url, params)
                .then(response => {
                    response = response.data

                    if(response.success){
                        this.$emit('refreshTab')
                    } else {
                        console.log(response)
                    }

                })
                .catch((error) => {
                    if (error.response) {
                        alert(error.response.data.message);
                    }
                })




        },

        homestayRequestReply(id, status){
            let self = this,
                url = `/api/interactions/homestay/reply`;

            this.requestStatus = status

            self.$v.$touch();
            if (self.$v.requestForm.$invalid) {
                return false;
            }

            let params = {
                "interaction_id": +id,
                "status": status,
                "comment": this.requestForm.comment,
            }

            if(this.requestForm.phone){
                params = Object.assign(
                    {},
                    params,
                    {
                        "details": {
                            "phone":  this.requestForm.phone.replace(/([(]|[)])|(-)|(\s)/g,'')
                        }
                    })
            }


            switch (this.requestStatus){
                case 'rejected':
                    params = {
                        "interaction_id": +id,
                        "status": status,
                        "comment": this.requestForm.comment,
                    }

                    if(this.requestForm.phone){
                        params = Object.assign(
                            {},
                            params,
                            {
                                "details": {
                                    "phone":  this.requestForm.phone.replace(/([(]|[)])|(-)|(\s)/g,'')
                                }
                            })
                    }


                    break;
                case 'processed':
                    params = {
                        "interaction_id": +id,
                        "status": status,
                        "comment": this.requestForm.comment,
                    }

                    break;
                default:
                    break;
            }


            axios.post(url, params)
                .then(response => {
                    response = response.data

                    if(response.success){
                        this.$emit('refreshTab')
                    } else {
                        console.log(response)
                    }

                })
                .catch((error) => {
                    if (error.response) {
                        alert(error.response.data.message);
                    }
                })

        },

        donorshipRequestReply(id, status){
            let self = this,
                url = `/api/interactions/donorship/reply`;



            this.requestStatus = status

            self.$v.$touch();
            if (self.$v.requestForm.$invalid) {
                return false;
            }


            let params = {
                "interaction_id": +id,
                "status": status,
                "actual_till": this.requestForm.timeTo,
                "comment": this.requestForm.comment,
            }

            if(this.requestForm.phone){
                params = Object.assign(
                    {},
                    params,
                    {
                        "details": {
                            "phone":  this.requestForm.phone.replace(/([(]|[)])|(-)|(\s)/g,'')
                        }
                    })
            }


            switch (this.requestStatus){
                case 'rejected':
                    params = {
                        "interaction_id": +id,
                        "status": status,
                        "actual_till": this.requestForm.timeTo,
                        "comment": this.requestForm.comment,
                    }

                    if(this.requestForm.phone){
                        params = Object.assign(
                            {},
                            params,
                            {
                                "details": {
                                    "phone":  this.requestForm.phone.replace(/([(]|[)])|(-)|(\s)/g,'')
                                }
                            })
                    }


                    break;
                case 'processed':
                    params = {
                        "interaction_id": +id,
                        "status": status,
                        "comment": this.requestForm.comment,
                    }

                    if(this.requestForm.phone){
                        params = Object.assign(
                            {},
                            params,
                            {
                                "details": {
                                    "phone":  this.requestForm.phone.replace(/([(]|[)])|(-)|(\s)/g,'')
                                }
                            })
                    }

                    break;
                default:
                    break;
            }


            axios.post(url, params)
                .then(response => {
                    response = response.data

                    if(response.success){
                        this.$emit('refreshTab')
                    } else {
                        console.log(response)
                    }

                })
                .catch((error) => {
                    if (error.response) {
                        alert(error.response.data.message);
                    }
                })
        },

        petOwershipRequestReply(requestId, requestStatus){
            let self = this,
                url = `/api/interactions/ownership/reply`;

            this.requestStatus = requestStatus

            self.$v.$touch();
            if (self.$v.requestForm.$invalid) {
                return false;
            }

            let params = {
                "interaction_id": requestId,
                "status": requestStatus,
                "comment": this.requestForm.comment,
                "details": {
                    "phone": this.requestForm.phone ? this.requestForm.phone.replace(/([(]|[)])|(-)|(\s)/g,'') : null,
                    "social": []

                }
            }

            switch (this.requestStatus){
                case 'rejected':
                    params = {
                        "interaction_id": requestId,
                        "status": requestStatus,
                    }

                    if( this.notice.sender_id ) params.comment = this.requestForm.comment

                    if(this.requestForm.phone){
                        params = Object.assign(
                            {},
                            params,
                            {
                                "details": {
                                    "phone":  this.requestForm.phone.replace(/([(]|[)])|(-)|(\s)/g,''),
                                    "social": []
                                }
                            })
                    }

                    break;
                case 'processed':
                    params = {
                        "interaction_id": requestId,
                        "status": requestStatus,
                    }

                    if( this.notice.sender_id ) params.comment = this.requestForm.comment

                    break;
                default:
                    break;
            }


            axios.post(url, params)
                .then(response => {
                    response = response.data

                    if(response.success){
                        this.$emit('refreshTab')
                    } else {
                        console.log(response)
                    }

                })
                .catch((error) => {
                    if (error.response) {
                        alert(error.response.data.message);
                    }
                })
        },

    }



}
</script>

<style scoped>

</style>
